/**
 * @function
 * @description useSvg Hook to implement common features of UX supplied svg icons.
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon as a float. The default is 1.
 * @param {number} viewBoxWidth Width of the svg viewbox.
 * @param {number} viewBoxHeight Height of the svg viewbox.
 * @returns {Array} [fill, width, height], fill for the svg icon, width for the svg icon, height for the svg icon.
 */
const useSvg = (props, viewBoxWidth, viewBoxHeight) => {
  const fill = props.fill || 'currentcolor'
  const scale = props.scale || 1.0
  const width = scale * viewBoxWidth
  const height = scale * viewBoxHeight
  return [fill, width, height]
}

export default useSvg
